<template>
  <PopupModal :open="open" has-close-button @close="close">
    <template #body>
      <div>
        <div>
          <AssistantSmiling class="mx-auto mb-8" />
        </div>
        <div class="text-large mb-8">
          {{ t("comp.challenge.started.tab.team.leave.team.dialog.title") }}
        </div>
        <div>
          {{ t("comp.challenge.started.tab.team.leave.team.dialog.text") }}
        </div>
      </div>
    </template>
    <template #footer>
      <div class="flex flex-row w-full justify-center gap-4">
        <div class="text-center">
          <ButtonElement
            :label="
              t('comp.challenge.started.tab.team.leave.team.dialog.cancel')
            "
            :disabled-visible="true"
            @click="close"
          />
        </div>
        <div class="text-center">
          <ButtonElement
            :label="
              t('comp.challenge.started.tab.team.leave.team.dialog.confirm')
            "
            @click="leave"
          />
        </div>
      </div>
    </template>
  </PopupModal>
</template>
<script setup lang="ts">
import PopupModal from "../layout/PopupModal.vue";
import ButtonElement from "../form/ButtonElement.vue";
import AssistantSmiling from "../icon/AssistantSmiling.vue";
import { useUserStore } from "../../../store/v2/user.js";
import { useI18n } from "vue-i18n";
import { useRouter } from "vue-router";
import { leaveTeam } from "../../../api/v2/competitive-challenge.ts";

const { t } = useI18n();

const router = useRouter();
const user = useUserStore();
const emit = defineEmits(["close", "updateHistory"]);

const props = defineProps({
  open: {
    type: Boolean,
    required: true,
  },
  teamId: {
    type: Number,
  },
  challengeId: {
    type: String,
  },
});

async function leave() {
  const res = await leaveTeam(user.externalUserId, props.teamId);

  if (res) {
    emit("close");
    router.push({
      name: "competitiveChallengeJoinTeam",
      params: { challengeId: props.challengeId },
    });
  }
}

function close() {
  emit("close");
}
</script>
